import React, { useEffect, useRef, useState } from "react";
import "./TaxPdfViewer.css";

const TaxPdfActionIcon = ({ name }) => {
  const paths = {
    close: (
      <>
        <path d="M6 6l12 12" />
        <path d="M18 6L6 18" />
      </>
    ),
    print: (
      <>
        <path d="M7 9V4h10v5" />
        <path d="M7 18H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <path d="M7 14h10v6H7z" />
        <path d="M17 12h.01" />
      </>
    ),
    download: (
      <>
        <path d="M12 3v12" />
        <path d="M7 10l5 5 5-5" />
        <path d="M5 21h14" />
      </>
    ),
  };

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      {paths[name]}
    </svg>
  );
};

const savePdf = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL?.(url), 1000);
};

export default function TaxPdfViewer({
  blob,
  fileName,
  title = "कर दस्तऐवज",
  onClose,
}) {
  const [pdfUrl, setPdfUrl] = useState("");
  const frameRef = useRef(null);

  useEffect(() => {
    if (!blob) return undefined;
    const url = URL.createObjectURL(blob);
    setPdfUrl(url);
    return () => URL.revokeObjectURL?.(url);
  }, [blob]);

  const printPdf = () => {
    const frameWindow = frameRef.current?.contentWindow;
    if (frameWindow) {
      frameWindow.focus();
      frameWindow.print();
      return;
    }
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  if (!blob) return null;

  return (
    <div className="tax-pdf-backdrop" onMouseDown={onClose}>
      <section
        className="tax-pdf-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="tax-pdf-toolbar">
          <div>
            <span>अधिकृत PDF</span>
            <strong>{title}</strong>
          </div>
          <div className="tax-pdf-actions">
            <button
              className="tax-pdf-icon-action"
              type="button"
              title="बंद करा"
              aria-label="बंद करा"
              data-tooltip="बंद करा"
              onClick={onClose}
            >
              <TaxPdfActionIcon name="close" />
            </button>
            <button
              className="tax-pdf-icon-action"
              type="button"
              title="छापा"
              aria-label="छापा"
              data-tooltip="छापा"
              disabled={!pdfUrl}
              onClick={printPdf}
            >
              <TaxPdfActionIcon name="print" />
            </button>
            <button
              className="tax-pdf-icon-action primary"
              type="button"
              title="PDF डाउनलोड करा"
              aria-label="PDF डाउनलोड करा"
              data-tooltip="PDF डाउनलोड करा"
              onClick={() => savePdf(blob, fileName)}
            >
              <TaxPdfActionIcon name="download" />
            </button>
          </div>
        </header>
        <div className="tax-pdf-stage">
          {pdfUrl ? (
            <iframe
              ref={frameRef}
              src={`${pdfUrl}#toolbar=0&navpanes=0&view=FitH`}
              title={title}
            />
          ) : (
            <div className="tax-pdf-loading">PDF उघडत आहे…</div>
          )}
        </div>
      </section>
    </div>
  );
}
